import {ID, Response} from '../../../../../../../../../_metronic/helpers'

export type User = {
  id?: ID
  name?: string
  avatar?: string
  email?: string
  username?: string
  firstname?: string
  lastname?: string
  position?: string
  role?: string
  last_login?: string
  two_steps?: boolean
  joined_day?: string
  online?: boolean
  initials?: {
    label: string
    state: string
  }
}

export type UsersQueryResponse = Response<Array<User>>

export const initialUser: User = {
  avatar: 'avatars/300-6.jpg',
  position: 'Art Director',
  role: 'Administrator',
  name: '',
  email: '',
}

export interface IUsers {
  id?: ID
  uuid?: string
  username?: string
  firstname?: string
  lastname?: string
  email?: string
  password?: string
  confirm_password?: string
  device_name?: string
}

export const UsersInitValues: IUsers = {
  username: '',
  firstname: '',
  lastname: '',
  email: '',
  password: '',
  confirm_password: '',
  device_name: '',
}

export interface RelatedFiles {
  id?: number
  uuid?: string
  url?: string
  description?: string 
  linkable_id?: number
  linkable_type?: string
   
}

export const initialValues: RelatedFiles = { 
 
}

export type RelatedFilesQueryResponse = Response<Array<RelatedFiles>>

export const RelatedFilesInitValues: RelatedFiles = { 
 
}
